<template>
  <section>
    <div id="news-setup" class="job-setup relative">
      <div class="background-aslant module-default relative w-full px-6 pb-48">
        <div class="mx-auto max-w-[55rem]">

          <!-- TITLE -->
          <!-- <div class="mb-6 pt-24 sm:mb-8 sm:pt-40"> -->
          <!--   <h1 class="title">{{ translations.prepare_news_title }}</h1> -->
          <!-- </div> -->

          <!-- TEXT -->
          <div
            class="text mb-16 sm:mb-20"
            v-html="translations.prepare_news_subtitle"
          />
          <!-- SUB TITLE -->
          <div class="mb-6 mt-9 sm:mb-9 sm:mt-16">
            <h2 class="subtitle">
              {{ translations.event_form_subtitle }}
            </h2>
          </div>

          <Form
            v-if="prepareNewsForm"
            ref="form"
            v-slot="{ errors }"
            key="0"
            class="form pt-24 sm:pt-32 2xl:pt-48"
            novalidate
            @submit="submit"
          >
            <div class="grid grid-cols-2 gap-5 sm:grid-cols-12 sm:gap-8">
              <template v-for="field in prepareNewsForm.fields">
                <!-- SECOND TITLE -->
                <div
                  v-if="field.handle === 'job_contact_email'"
                  :key="field.handle"
                  class="col-span-1 mb-2 mt-9 sm:col-span-6 sm:mb-2 sm:mt-16"
                >
                  <h2 class="subtitle">
                    {{ translations.job_form_contact_subtitle }}
                  </h2>
                </div>
                <InputField
                  v-if="field.type === 'text' || field.type === 'email'"
                  :id="field.handle"
                  :key="field.handle"
                  :value="form[field.handle]"
                  class="input relative"
                  :rules="prepareNewsForm.rules[field.handle]"
                  :class="[mapColSpan(field.width)]"
                  :field="field"
                  :errors="errors"
                  @field-input="form[field.handle] = $event"
                />
                <div
                  v-if="field.type === 'textarea'"
                  :key="field.handle"
                  class="input relative row-span-4"
                  :class="mapColSpan(field.width)"
                >
                  <Field
                    v-model="form[field.handle]"
                    :rules="
                      field.handle === 'comment'
                        ? 'max:300'
                        : 'required|max:300'
                    "
                    as="textarea"
                    :name="field.handle"
                    maxlength="250"
                    class="peer"
                    :class="{ '!border-primary-red': errors[field.handle] }"
                  />
                  <label
                    class="peer-placeholder-shown:text-custom-light-blue-gray pointer-events-none absolute -top-3 left-3 mr-2 text-sm text-white transition-all peer-placeholder-shown:top-[1.125rem] peer-placeholder-shown:!text-[1.1875rem] peer-focus:-top-3 peer-focus:!text-sm peer-focus:text-white"
                    :for="field.handle"
                    :class="{
                      'peer-placeholder-shown:!text-custom-light-blue-gray !text-primary-red':
                        errors[field.handle],
                    }"
                  >
                    {{ translations[field.handle] }}
                  </label>
                </div>

                <!-- FILE UPLOAD -->
                <div
                  v-if="field.type === 'assets'"
                  :key="field.handle"
                  class="input relative h-14 w-full rounded-[0.25rem] border-2 border-white font-[1.1875rem] text-white outline-none"
                  :class="[
                    mapColSpan(field.width),
                    { '!border-primary-red': errors[field.handle] },
                  ]"
                >
                  <Field
                    v-model="form[field.handle]"
                    :name="field.handle"
                    class="peer cursor-pointer opacity-0"
                    type="file"
                    accept="image/*"
                    rules="image"
                  />
                  <label
                    class="pointer-events-none absolute -top-3 left-3 line-clamp-1 text-sm text-primary-blue-gray transition-all peer-focus:-top-3 peer-focus:!text-sm peer-focus:text-white sm:line-clamp-none"
                    :for="field.handle"
                    :class="[
                      {
                        'peer-placeholder-shown:!text-custom-light-blue-gray !text-primary-red':
                          errors[field.handle],
                      },
                      form[field.handle]
                        ? ''
                        : 'text-custom-light-blue-gray top-[1.125rem] !text-[1.1875rem]',
                    ]"
                  >
                    {{ translations[field.handle] }}
                  </label>

                  <!-- TEXT & BUTTON OVERLAY -->
                  <div
                    class="pointer-events-none absolute inset-0 flex items-center justify-between"
                  >
                    <p
                      class="w-auto max-w-full overflow-hidden text-ellipsis px-4"
                    >
                      {{ form[field.handle]?.name }}
                    </p>
                    <div
                      class="flex h-full items-center bg-white px-4 text-base font-medium uppercase text-primary-blue"
                    >
                      {{ translations.event_upload_image_button }}
                    </div>
                  </div>

                  <p
                    v-if="errors[field.handle]"
                    class="error !mt-[-0.125rem] !text-sm"
                  >
                    {{ translations.is_required }}
                  </p>
                </div>
              </template>

              <input name="honigchuebel" type="hidden" />
            </div>
            <button
              class="button-secondary button mt-9 whitespace-nowrap !tracking-widest sm:mt-20"
              type="submit"
            >
              {{ translations.job_form_button_text }}
            </button>
          </Form>

          <!-- SUCCESS -->
          <transition name="fade">
            <div
              v-if="state === 'submitted'"
              ref="success"
              key="1"
              class="my-10 flex items-start space-x-4 text-white"
            >
              <CheckmarkIcon class="mt-2 h-4 w-4 shrink-0" />
              <p class="success">
                {{ translations.news_success_message }}
              </p>
            </div>
          </transition>

          <!-- ERROR -->
          <transition name="fade">
            <div
              v-if="state === 'error'"
              key="2"
              ref="error"
              class="my-10 flex items-start text-primary-red"
            >
              <p>
                {{ translations.submit_error }}
              </p>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { store } from '@/store'
import { Form, Field } from 'vee-validate'

export default {
  components: {
    Form,
    Field,
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      form: {},
      state: 'default',
    }
  },

  computed: {
    translations() {
      return store.translations || {}
    },

    prepareNewsForm() {
      return store.forms?.prepare_news || {}
    },
  },

  methods: {
    mapColSpan(width = 100) {
      switch (width) {
        case 25:
          return 'sm:col-span-3 col-span-1'
        case 33:
          return 'sm:col-span-4 col-span-2'
        case 50:
          return 'sm:col-span-6 col-span-2'
        case 66:
          return 'sm:col-span-8 col-span-2'
        default:
          return 'sm:col-span-12 col-span-2'
      }
    },

    scrollTo(element) {
      if (!element) return

      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      })
    },

    async submit(values, { resetForm }) {
      this.state = 'loading'

      if (!this.form.image) {
        // statamic throws an error if the field exists an is undefined
        delete this.form.image
      }

      // convert this.form to a form data instance
      const formData = new FormData()
      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key])
      })

      try {
        await $fetch(`${this.$config.public.API_URL}/!/forms/prepare_news`, {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          responseType: 'text', // prevents parse errors on empty bodies
        })
        // Wait until the models are updated in the UI
        await this.$nextTick()
        this.form = {}

        this.state = 'submitted'

        this.scrollTo(this.$refs.success)

        resetForm()
      } catch (e) {
        this.state = 'error'

        console.error(e)

        await this.$nextTick()
        this.scrollTo(this.$refs.error)
      }
    },
  },
}
</script>
